import { makeStyles, tokens, Spinner } from '@fluentui/react-components';
import { useMails } from '@/hooks/useMails';
import { MailRow } from './MailRow';

const useStyles = makeStyles({
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalXS,
    minHeight: '28px',
    color: tokens.colorNeutralForeground3,
    fontSize: tokens.fontSizeBase200,
  },
});

interface Props {
  folderId: string;
  depth: number;
}

// Rendered only while the parent folder is expanded, so the mails query is
// lazy (mounting triggers the fetch). Collapsed folders never fetch. An empty
// folder renders nothing — empty leaf folders aren't expandable in the first
// place (see FolderRow), so there's no "no mails" line to show.
export function FolderMails({ folderId, depth }: Props) {
  const styles = useStyles();
  const { data, isPending, isError } = useMails(folderId);
  const pad = { paddingLeft: `calc(${tokens.spacingHorizontalXS} + ${depth * 12}px)` } as const;

  if (isPending) {
    return (
      <div className={styles.row} style={pad}>
        <Spinner size="tiny" label="Chargement des mails…" />
      </div>
    );
  }
  if (isError) {
    return (
      <div className={styles.row} style={pad}>
        Impossible de charger les mails.
      </div>
    );
  }
  if (!data || data.length === 0) return null;

  return (
    <>
      {data.map((mail) => (
        <MailRow key={mail.id} mail={mail} depth={depth} />
      ))}
    </>
  );
}
